<app-layout [isFullscreenPage]="isFullscreenPage" [currentTitle]="currentTitle" [layoutColor]="layoutColor" [isBetaItem]="isBetaItem" [urlPath]="router.url">
  @if (this.isAdmin) {
    <app-admin-settings-modal></app-admin-settings-modal>
  }
  <router-outlet></router-outlet>
</app-layout>
<app-agent-panel></app-agent-panel>
